import { render } from "./order_list.vue?vue&type=template&id=83fec06c"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__